import ActivateCardModal from './ActivateCardModal';

export default ActivateCardModal;
